
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/riviste/[slug]/[numero]/risorse",
      function () {
        return require("private-next-pages/riviste/[slug]/[numero]/risorse.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/riviste/[slug]/[numero]/risorse"])
      });
    }
  